import { render } from "./TicketList.vue?vue&type=template&id=3c4feed9"
import script from "./js/ticketList.js?vue&type=script&lang=js&external"
export * from "./js/ticketList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__